const CustomPalette = {
  PilotBlue: '#463ED7',
  PilotBlue800: '#3132C8',
  PilotBlue900: '#001FB2',
  PilotBlueShadow: '#463ED740',
  PrimaryPilotBlue: '#846CFF',
  PrimaryPilotBlue2: '#6B58F6',
  PrimaryPilotBlueLight900: '#002DA2',
  NightBlue200: '#151830',
  SecondaryNightBlue900: '#363752',
  SecondaryNightBlue700: '#5B5C79',
  SecondaryNightBlue600: '#6F708E',
  SecondaryNightBlue400: '#9999B8',
  SecondaryNightBlue300: '#AEAECE',
  SecondaryNightBlue200: '#C4C4E5',
  SecondaryNightBlue100: '#DADAFC',
  SecondaryNightBlue50: '#F1F1FF',
  Cloud: '#C4CFD4',
  SecondaryCloud: '#F8F8FA',
  Air: '#D7D9F7',
  AirLight: '#F0F0F0',
  NightBlueLight: '#262B57',
  NightBlue400: '#15172E',
  Chip: '#5664E5',
  DisableGray: '#c2c2c2',
  SecondaryGreen: '#E1FAE0',
  SecondaryGreen300: '#98B097',
  NightBlueLight800: '#212121',
  SuccessLightGreen: '#4D824F',
  WarningLightOrange: 'rgba(192, 116, 2, 0.04)',
  white: '#FFFFFF',
  black: '#000000',
  WarningOrange: '#C07402',
  SuccessGreen: '#4D824F',
  ErrorRed: '#BA4926',
  ErrorRed4Percent: '#B42424',
  ErrorRed4PercentShadow: '#B424240A',
  GrayDot: '#D9D9D9',
  NeutralColor: '#B827A1',
  backgroundLanguageChip: '#F3F5F6',
  muiSwitchTrack: '#DCE0FB',
  muiSwitchChecked: '#5D5FEF',
}

export default CustomPalette
